module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"root":["AWSCognito"],"commonjs2":"aws-sdk/global","commonjs":"aws-sdk/global","amd":"aws-sdk/global"}
// module id = 1
// module chunks = 0